import { cn } from '@/lib/utils';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';

interface Props {
  label: string;
  value: React.ReactNode;
  /** Delta string e.g. "+12.4%" / "-3.2 pts" / "+1 deal". Optional. */
  delta?: string;
  deltaKind?: 'up' | 'down' | 'flat';
  /** Small icon at the start of the label row. */
  icon?: React.ReactNode;
  className?: string;
}

/**
 * KPI card — used in the Opportunities header strip and anywhere a single
 * metric needs to read at a glance.
 *
 * Up/down arrows colored success/warning; flat is neutral.
 */
export function KPIStat({ label, value, delta, deltaKind = 'up', icon, className }: Props) {
  const dKind = !delta ? null : deltaKind;
  return (
    <div
      className={cn(
        'rounded-md border bg-card px-4 py-3.5 shadow-sm',
        className,
      )}
    >
      <div className="flex items-center gap-1.5 text-[11.5px] font-medium uppercase tracking-[0.06em] text-muted-foreground">
        {icon}
        <span>{label}</span>
      </div>
      <div className="mt-1.5 text-[24px] font-[650] tracking-[-0.025em] tabular-nums text-foreground">
        {value}
      </div>
      {delta && (
        <div className={cn('mt-1.5 inline-flex items-center gap-1 text-xs font-medium',
          dKind === 'up'   ? 'text-success'  :
          dKind === 'down' ? 'text-destructive' :
                             'text-muted-foreground')}>
          {dKind === 'up'   && <ArrowUp className="h-3 w-3"/>}
          {dKind === 'down' && <ArrowDown className="h-3 w-3"/>}
          {dKind === 'flat' && <Minus className="h-3 w-3"/>}
          {delta}
        </div>
      )}
    </div>
  );
}
